// System directives

"use client";

// System dependencies

import { createBrowserClient } from "@supabase/ssr";
import { SupabaseClient } from "@supabase/supabase-js";

// Application dependencies

import { devConsole } from "@/lib/devConsole";

// Namespace

const NAMESPACE = "supabase-client";

// Environment variables set with typesafety

const SUPABASE_URL = process.env.NEXT_PUBLIC_SUPABASE_URL!;
const SUPABASE_ANON_KEY = process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY!;

// Singleton instance

let clientInstance: SupabaseClient | null = null;

// console.log("supabase/client",``);

export function createClient(): SupabaseClient {
  // Check to see whether we already have a client instance of the SupabaseClient and, if so, do nothing.

  if (!clientInstance) {
    // To be here we don't have an instance so we create one.

    devConsole.log(
      NAMESPACE,
      `createClient`,
      `Creating a new SupabaseClient CSR instance `
    );

    clientInstance = createBrowserClient(SUPABASE_URL, SUPABASE_ANON_KEY);
  }

  return clientInstance;
}

export const supabaseClient = createClient();
